import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withRoomContext } from '../../../RoomContext';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import * as settingsActions from '../../../actions/settingsActions';
import * as chatActions from '../../../actions/chatActions';
import * as roomActions from '../../../actions/roomActions';
import Icons from '../Common/Icons';

// firebase
import { storage } from '../../../lib/firebase';

const styles = () =>
	({
		root :
		{
			width          : '100%',
			height         : '100%',
			flexDirection  : 'column',
			display        : 'flex',
			justifyContent : 'center'
		},
		buttonRow :
		{
			width           : '100%',
			display         : 'flex',
			justifyContent  : 'space-between',
			marginBottom    : '10px',
			'&:first-child' : {
				marginRight : '10px'
			}

		},
		buttonRowSingle :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'center'

		},
		controlBtn :
		{
			borderRadius    : '5rem',
			fontSize        : '0.6rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'flex',
			flexDirection   : 'column',
			lineHeight      : 1.5,
			whiteSpace      : 'nowrap',
			aspectRatio     : 1,
			width           : '4.5rem',
			'&:hover'       :
			{
				backgroundColor : '#f50057'
			},
			'& .MuiButton-label' :
			{
				justifyContent : 'center',
				alignItems     : 'center',
				display        : 'flex',
				flexDirection  : 'column'
			}
		},
		controlBtnDisable :
		{
			borderRadius    : '5rem',
			fontSize        : '0.6rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'flex',
			flexDirection   : 'column',
			lineHeight      : 1.5,
			whiteSpace      : 'nowrap',
			aspectRatio     : 1,
			width           : '4.5rem',
			opacity         : 0.5,
			'&:hover'       :
			{
			},
			'& .MuiButton-label' :
			{
				justifyContent : 'center',
				alignItems     : 'center',
				display        : 'flex',
				flexDirection  : 'column',
				color          : '#ccc'
			}
		},
		controlBtnActive :
		{
			backgroundColor : '#9ec317',
			color           : 'white',
			boxShadow       : '2px 2px 4px inset #aaa'
		},
		hiddenInput :
		{
			display : 'none'
		},
		buttonCircular : {
			color  : '#adadac',
			height : '24px !important',
			width  : '24px !important'
		}
	});

const HomeMeetingControls = ({
	room,
	roomClient,
	classes,
	settings,
	holding,
	finishMeeting,
	displayName,
	picture,
	uploadedShareFile
}) =>
{
	const hiddenFileInput = useRef();

	const [ isUploadingFile, setIsUploadingFile ] = useState(false);

	const handleHolding = async () =>
	{
		await roomClient.changeHolding(!holding);
	};

	const handleMute = async () =>
	{
		if (settings.audioMuted)
		{
			await roomClient.unmuteMic();
		}
		else
		{
			await roomClient.muteMic();
		}
	};

	const createFileShareInfo = (sender, name, pic, fileName, fileShareUrl) =>
		({
			type    : 'file',
			time    : Date.now(),
			name,
			sender,
			picture : pic,
			fileName,
			fileShareUrl
		});

	const startShareFile = () =>
	{
		hiddenFileInput.current.click();
	};

	const handleShareFile = async (event) =>
	{

		const fileUploaded = event.target.files[0];

		const fileReader = new FileReader();

		fileReader.onload = async function()
		{
			try
			{
				setIsUploadingFile(true);
				let url='';

				const fileName=fileUploaded.name;

				const timeStamp = new Date().getTime();
				// firebase storage  room.name is id of room collection
				const storageref = storage.ref(`/sharedFiles/${room.name}/${timeStamp}-${fileName}`);

				const snapshot = await storageref.put(fileUploaded);

				url = await snapshot.ref.getDownloadURL();

				if (url)
				{
					const fileInfo = createFileShareInfo('response', displayName, picture, fileName, url);

					roomClient.shareFirebaseFile(fileInfo);
					setIsUploadingFile(false);
				}
				else
				{
					// notify error
					uploadedShareFile({
						fileName     : fileName,
						fileShareUrl : '',
						error        : true
					});
					setIsUploadingFile(false);
				}

			}
			catch
			{
				// notify error
				uploadedShareFile({
					fileName     : fileUploaded.name,
					fileShareUrl : '',
					error        : true
				});
				setIsUploadingFile(false);
			}
		};

		try
		{
			fileReader.readAsDataURL(fileUploaded);
		}
		catch
		{
			// notify error
			uploadedShareFile({
				fileName     : 'ファイル',
				fileShareUrl : '',
				error        : true
			});
		}

	};

	return (
		<div className={classes.root}>
			<div className={classes.buttonRow}>
				<Button
					className={classnames(
						classes.controlBtn
					)}
					onClick={() => handleHolding()}
				>
					<Icons category={'host'} iconName={'hold'} type={holding ? 'active': 'normal'} size={'2rem'}/>
					<p>保留</p>
				</Button>
				<Button
					className={classnames(
						classes.controlBtn
					)}
					onClick={() => handleMute()}
				>
					<Icons category={'host'} iconName={'mute'} type={settings.audioMuted ? 'active': 'normal'} size={'1rem'}/>
					<p>ミュート</p>
				</Button>
			</div>
			<div className={classes.buttonRow}>
				<Button
					className={classnames(
						classes.controlBtn
					)}
					onClick={() => roomClient.updateScreenSharing({ start: true })}
				>
					<Icons category={'host'} iconName={'screenShare'} type={'normal'} size={'1.5rem'}/>
					<p>画面共有</p>
				</Button>
				{
					isUploadingFile ?
						<Button
							className={classnames(
								classes.controlBtn
							)}
						>
							<span>
								<CircularProgress
									className={classnames(
										classes.buttonCircular
									)}
								/>
							</span>

							<p>ファイル共有</p>
						</Button>
						:
						<Button
							className={classnames(
								classes.controlBtn
							)}
							onClick={() => startShareFile()}
						>
							<Icons category={'host'} iconName={'fileShare'} type={'normal'} size={'1.5rem'}/>
							<p>ファイル共有</p>
						</Button>

				}
			</div>
			<div className={classes.buttonRowSingle}>
				<Button
					className={classnames(
						classes.controlBtn
					)}
					onClick={() => finishMeeting()}
				>
					<Icons category={'host'} iconName={'hungUp'} type={'normal'} size={'1.7rem'}/>
					<p>通話終了</p>
				</Button>
			</div>

			{/* hidden input in order to update file */}
			<input
				type='file'
				ref={hiddenFileInput}
				onChange={handleShareFile}
				className={classnames(
					classes.hiddenInput
				)}
			/>

		</div>
	);
};

HomeMeetingControls.propTypes =
{
	room              : PropTypes.object.isRequired,
	roomClient        : PropTypes.object.isRequired,
	classes           : PropTypes.object.isRequired,
	settings          : PropTypes.object.isRequired,
	setAudioMuted     : PropTypes.func.isRequired,
	setVideoMuted     : PropTypes.func.isRequired,
	uploadedShareFile : PropTypes.func.isRequired,
	holding           : PropTypes.bool.isRequired,
	finishMeeting     : PropTypes.func.isRequired,
	displayName       : PropTypes.string,
	picture           : PropTypes.string
};

const mapStateToProps = (state) =>
{
	return {
		room        : state.room,
		settings    : state.settings,
		holding     : state.settings.holding,
		displayName : state.settings.displayName,
		picture     : state.me.picture
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		uploadedShareFile : (fileInfo) =>
		{
			dispatch(chatActions.uploadedShareFile(fileInfo));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.settings.displayName === next.settings.displayName &&
				prev.settings.holding === next.settings.holding &&
				prev.settings === next.settings
			);
		}
	}
)(withStyles(styles)(HomeMeetingControls)));